/* ZYMA ingredient index — sections/zyma-ingredient-index.liquid
   Filters rows by search text and by a product or goal chip; hides empty groups; announces the count. */
(() => {
  if (customElements.get('zyma-ingredient-index')) return;

  class ZymaIngredientIndex extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.filter = 'all';
      this.input = this.querySelector('[data-ingr-search]');
      this.chips = [...this.querySelectorAll('[data-ingr-filter]')];
      this.groups = [...this.querySelectorAll('[data-ingr-group]')];
      this.count = this.querySelector('[data-ingr-count]');
      this.empty = this.querySelector('[data-ingr-empty]');
      this.clear = this.querySelector('[data-ingr-clear]');

      // The form posts to /search without JS; with JS it filters in place, so submitting only closes the keyboard.
      this.querySelector('[data-ingr-form]')?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.input?.blur();
      });
      this.input?.addEventListener('input', () => this.apply());
      this.input?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.input.value) {
          event.preventDefault();
          this.clearQuery();
        }
      });
      this.clear?.addEventListener('click', () => this.clearQuery());
      this.chips.forEach((chip) => chip.addEventListener('click', () => this.setFilter(chip.dataset.ingrFilter)));
      this.querySelector('[data-ingr-reset]')?.addEventListener('click', () => {
        if (this.input) this.input.value = '';
        this.setFilter('all');
        this.input?.focus();
      });

      this.apply();
    }

    clearQuery() {
      if (this.input) this.input.value = '';
      this.apply();
      this.input?.focus();
    }

    setFilter(value) {
      this.filter = value || 'all';
      this.chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.ingrFilter === this.filter)));
      this.apply();
    }

    apply() {
      const query = (this.input?.value || '').trim().toLowerCase();
      const [type, value] = this.filter.split(':');
      let total = 0;

      if (this.clear) this.clear.hidden = !this.input?.value;

      this.groups.forEach((group) => {
        const groupMatches =
          this.filter === 'all' ||
          (type === 'product' && group.dataset.product === value) ||
          (type === 'goal' && group.dataset.goal === value);
        let shown = 0;
        group.querySelectorAll('[data-ingr-row]').forEach((row) => {
          const visible = groupMatches && (!query || (row.dataset.search || '').includes(query));
          row.hidden = !visible;
          if (visible) shown += 1;
        });
        group.hidden = shown === 0;
        total += shown;
      });

      if (this.count) {
        const template = total === 1 ? this.dataset.countOne : this.dataset.countOther;
        this.count.textContent = (template || '[count]').replace('[count]', total);
      }
      if (this.empty) this.empty.hidden = total > 0;
    }
  }

  customElements.define('zyma-ingredient-index', ZymaIngredientIndex);
})();
